'use strict';
const angular = require('angular');

export class VendorLookupComponent {
  /*@ngInject*/
  constructor(VendorService) {
    this.VendorService = VendorService;

    this.data = [];

    this.VendorService.query((data) => {
      this.data = data;
      this.dataInitComplete = true;
    }, err => {
      console.log("Could not retrieve vendors.")
    });
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok(property) {
    this.close({$value: property});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  getPrimaryAddress(vendor) {
    let primary = vendor.address.find(addr => addr.isPrimary == true);

    if (!primary)
      return "-";

    return primary.street + "<br/>" + primary.city + ' ' + primary.state + ', ' + primary.zip;
  }
}

export default angular.module('conduu.vendorLookup', [])
  .component('vendorLookup', {
    template: require('./vendor-lookup.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: VendorLookupComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/vendor-lookup/vendor-lookup.component.js